<!-- <ion-content id="set" >
<div class="new-order">NewOrder?</div>
<p class="para">You currently have items from other restaurants in your cart.
Would you like to clear your cart and start a new order?</p>
<div class="buttons">
  <button (click)="continue()" class="btns">Yes</button><button class="btns" (click)="discontinue()" >No</button>
</div>
</ion-content> -->

<!-- <ion-content id="set" *ngIf="item">
<div class="new-order">{{'Confirmation.NewOrder' | translate}}</div>
<p class="para">{{'Confirmation.Warning' | translate}}</p>
<div class="buttons">
  <button (click)="continue()" class="btns">{{'General.Yes' | translate}}</button><button class="btns" (click)="discontinue()" >{{'General.No' | translate}}</button>
</div>
</ion-content> -->


@if (orderType == 'pickup' && !confirmedAddress && !noItem && storeAddress) {
  <ion-content>
    <div class="title sub-title">{{'Confirmation.PickupAddressConfirmation' | translate }}</div>
    <p class="para">
      {{ storeAddress.streetNumber }}  {{ storeAddress.street }}, {{ storeAddress.city }}, {{ storeAddress.postalCode }}
    </p>
    <div class="buttons">
      <button (click)="confirmAddress()" class="btns continue">{{'General.Confirm' | translate}}</button>
      <button (click)="discontinue()" class="btns"  >{{'General.Cancel' | translate}}</button>
    </div>
  </ion-content>
}

@if (orderType == 'delivery' && !confirmedAddress && !noItem && deliveryAddress) {
  <ion-content>
    <div class="title sub-title">{{'Confirmation.DeliveryAddressConfirmation' | translate }}</div>
    <p class="para">
      {{ deliveryAddress.streetNumber }}  {{ deliveryAddress.street }}, {{ deliveryAddress.city }}, {{ deliveryAddress.postalCode }}
    </p>
    <div class="buttons">
      <button (click)="confirmAddress()" class="btns continue">{{'General.Confirm' | translate}}</button>
      <button (click)="changeAddress()" class="btns">{{'Address.Change' | translate}}</button>
      <button (click)="discontinue()" class="btns"  >{{'General.Cancel' | translate}}</button>
    </div>
  </ion-content>
}

@if (!noItem && !unavailableItems && change && confirmedAddress) {
  <ion-content>
    <div class="title">{{'Confirm.Continue' | translate}}</div>
    <p class="para">{{'Confirm.Para' | translate}}</p>
    @for (item of changedPriceItems; track item) {
      <p class="items">
        -{{item.itemName}}: <span style="text-decoration: line-through;">${{item.oldPrice | currency:'USD':true:'1.2-2'}}</span> -> {{item.newPrice | currency:'USD':true:'1.2-2'}}
      </p>
    }
    <div class="buttons">
      <button (click)="continue()" class="btns continue">{{'Confirm.Yes' | translate}}</button><button (click)="discontinue()" class="btns"  >{{'Confirm.No' | translate}}</button>
    </div>
  </ion-content>
}

@if (noItem) {
  <ion-content>
    <div class="title">{{'Confirmation.NoItemHeading' | translate}}</div>
    <p class="para">{{'Confirmation.NoItemUnavailable' | translate}}</p>
    <div class="button" (click)="discontinue()">
      <button class="btns" (click)="discontinue()" >OK</button>
    </div>
  </ion-content>
}

@if (!noItem && unavailableItems && confirmedAddress) {
  <ion-content>
    <ion-content>
      <div class="title">{{'Confirmation.NoItemHeading' | translate}}</div>
      <p class="para">{{'Confirmation.NoItemUnavailable' | translate}}</p>
      @for (item of unavailableItems; track item) {
        <p class="items">
          -{{item.name}}
        </p>
      }
      <div class="buttons">
        <button (click)="next()" class="btns continue">{{'General.Continue' | translate}}</button><button (click)="discontinue()" class="btns"  >{{'General.Cancel' | translate}}</button>
      </div>
    </ion-content>
  </ion-content>
}

